import React from "react";

import { useHomeContentSettings } from "./hooks/useHomeContentSettings";

import HomeContentHeader from "./components/HomeContentHeader";
import HomeContentKpiCards from "./components/HomeContentKpiCards";
import HomeContentForm from "./components/HomeContentForm";
import HomePreviewPanel from "./components/HomePreviewPanel";
import HeaderUploadDrawer from "./components/HeaderUploadDrawer";

export default function SettingsHomeContent() {
  const dashboard = useHomeContentSettings();

  const formId = "home-content-settings-form";

  return (
    <div className="space-y-5">
      <HomeContentHeader
        formId={formId}
        saving={dashboard.saving}
        loading={dashboard.loading}
      />

      {/* <HomeContentKpiCards
        stats={dashboard.stats}
        loading={dashboard.loading}
      /> */}

      <div className="grid gap-5 2xl:grid-cols-[minmax(0,1fr),520px]">
        <HomeContentForm
          formId={formId}
          settings={dashboard.settings}
          galleries={dashboard.galleries}
          selectedGallery={dashboard.selectedGallery}
          loading={dashboard.loading}
          saving={dashboard.saving}
          headerImages={dashboard.headerImages}
          onChange={dashboard.handleChange}
          onContentChange={dashboard.handleContentChange}
          onSubmit={dashboard.saveSettings}
          onOpenUpload={dashboard.openUploadDrawer}
        />

        <HomePreviewPanel
          settings={dashboard.settings}
          headerImages={dashboard.headerImages}
          selectedGallery={dashboard.selectedGallery}
          carrouselPhotos={dashboard.carrouselPhotos}
          previewDark={dashboard.previewDark}
          setPreviewDark={dashboard.setPreviewDark}
          slide={dashboard.slide}
          setSlide={dashboard.setSlide}
          autoPlay={dashboard.autoPlay}
          setAutoPlay={dashboard.setAutoPlay}
        />
      </div>

      <HeaderUploadDrawer
        isOpen={dashboard.uploadDrawerOpen}
        uploadTarget={dashboard.uploadTarget}
        uploading={dashboard.uploading}
        uploadProgress={dashboard.uploadProgress}
        onClose={dashboard.closeUploadDrawer}
        onSubmit={dashboard.handleUploadHeader}
      />
    </div>
  );
}